import {useLayoutEffect, useState, useEffect} from 'react';
import {Platform} from 'react-native';
import {storage, StorageKeys} from '../../shared/storage';
import {httpService, HttpWrapperOptions} from '../../shared/httpWrapper';
import {getApiRoute} from '../../shared/pipes';
import {apiUrls} from '../../shared/constants/urls';
import View from './view';

export const LoginScreen = () => {
  const isWeb = Platform.OS === 'web';
  const [esiaLogoutLink, setEsiaLogoutLink] = useState<string | null>(null);

  useLayoutEffect(() => {
    const esiaLogout = async () => {
      const isESIALogin = await storage.getItem(StorageKeys.isESIA);
      if (isESIALogin) {
        const {link} = await httpService.get<{link: string}>(
          getApiRoute(apiUrls.esiaLogout),
          new HttpWrapperOptions().WaitTimeout(0).Wait(true),
        );
        setEsiaLogoutLink(link ?? null);
      }
    };

    esiaLogout();
  }, []);

  useEffect(() => {
    storage.removeItem(StorageKeys.activationToken);
  }, []);

  if (isWeb && esiaLogoutLink) {
    window.open(esiaLogoutLink, '_self');
    return null;
  }

  return View({esiaLogoutLink});
};
